import { useParams } from "react-router-dom";
import { usePersona, type Persona } from "../../hooks/usePersona";
import { OwnerHome } from "./OwnerHome";
import { OperatorHome } from "./OperatorHome";
import { StaffHome } from "./StaffHome";
import { ApproverHome } from "./ApproverHome";
import { ReviewerHome } from "./ReviewerHome";

const HOMES: Record<Persona, () => JSX.Element> = {
  owner: OwnerHome,
  operator: OperatorHome,
  staff: StaffHome,
  approver: ApproverHome,
  reviewer: ReviewerHome,
  // CXO uses the OwnerHome surface — same workspace-summary lens.
  cxo: OwnerHome,
};

export function PersonaHome() {
  const { workspaceId } = useParams<{ workspaceId: string }>();
  const persona = usePersona(workspaceId);

  if (persona === null) {
    return (
      <div className="main-inner" data-testid="persona-home-loading">
        <div
          style={{ height: 24, width: 240, background: "var(--bg-soft)", borderRadius: 4 }}
        />
      </div>
    );
  }

  const Home = HOMES[persona];
  return <Home />;
}
